export default function VendorsController(
  $q,
  $rootScope,
  $scope,
  alerts,
  vmSharedModelService,
  confirmDialog,
  editVendorDialog,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.hasData = false;
  vm.handleEdit = _handleEdit;
  vm.handleDelete = _handleDelete;

  // _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleEdit($event, vendor) {
    return _showEditVendorDialog($event, { vendor });
  }

  function _handleDelete($event, vendor) {
    ssDialogService.dialogs.bcp.confirmDeleteVendorDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Vendor?',
        message: `Are you sure you want to delete the Vendor "${vendor.name}"?`,
        handleYesClick() {
          _deleteVendor(vendor.vendorId);
        },
        handleNoClick: _closeConfirmDeleteDialog,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteVendorDialog);
  }

  /** **************************************************
   * Private Functions
   */

  function _deleteVendor(vendorId) {
    loaderService.showViewLoader = true;
    return vmSharedModelService.deleteVendor(vendorId)
      .then(() => {
        alerts.success('The Vendor has been deleted successfully.');
        $rootScope.$broadcast('vendorDeleted', vendorId);
      }).catch(() => {
        alerts.error('Error occurred while deleting Vendor.');
      }).finally(() => {
        loaderService.showViewLoader = false;
        return _closeConfirmDeleteDialog();
      });
  }

  function _showEditVendorDialog($event, locals) {
    ssDialogService.dialogs.bcp.editVendorDialog = ssDialogService.alert(
      editVendorDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editVendorDialog);
  }

  function _closeConfirmDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteVendorDialog);
  }
}

VendorsController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'vmSharedModelService',
  'confirmDialog',
  'bcp.editVendorDialog',
  'loaderService',
  'ssDialogService',
];
